import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "../../../assets/images/clear.svg";
import Modal from "@material-ui/core/Modal";
import React from "react";
import { useStylesBoa } from "./style";
import { withTranslation } from "react-i18next";

const SenderDeleteModal = ({ deleteSenderConfirm, openConfirmDeletion, t }) => {
  const classes = useStylesBoa();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openConfirmDeletion}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={openConfirmDeletion}>
        <div className={`${classes.paper} ${"modalBg"}`}>
          <img
            alt="CloseIcon"
            className="ClearModalImg"
            src={CloseIcon}
            onClick={(e) => deleteSenderConfirm(false)}
          />
          <div className="modal-msg">
            <p>
              {t(
                "Are_you_sure_you_want_to_delete_the_selected_senders_address"
              )}
            </p>
          </div>
          <div className="modal_footer">
            <button
              className="senderBtn"
              onClick={(e) => deleteSenderConfirm(true)}
            >
              {t("Yes")}
            </button>
            <button
              className="cancel_btn"
              onClick={(e) => deleteSenderConfirm(false)}
            >
              {t("No")}
            </button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};
export default withTranslation()(SenderDeleteModal);
